var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highcharts',{staticClass:"pres_hc",attrs:{"options":_vm.tagsChart}})
}
var staticRenderFns = []

export { render, staticRenderFns }